var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.3431 0.92888L22.7071 7.29284C23.0976 7.68336 23.0976 8.31653 22.7071 8.70705L16.3431 15.071C15.9526 15.4615 15.3195 15.4615 14.9289 15.071C14.5384 14.6805 14.5384 14.0473 14.9289 13.6568L19.5858 8.99995H0V6.99995H19.5858L14.9289 2.34309C14.5384 1.95257 14.5384 1.3194 14.9289 0.92888C15.3195 0.538355 15.9526 0.538355 16.3431 0.92888Z"}));
}

ArrowRight.defaultProps = {"width":"23","height":"16","viewBox":"0 0 23 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
